import Menu, { sortMenu } from './menu.js';

const menu = [
  {
    title: 'Assemblages',
    group: 'apps',
    icon: '$iconComponent',
    name: 'Composites',
    order: 6,
  },
  {
    title: 'Utilisateurs',
    group: 'apps',
    icon: '$iconUser',
    name: 'Users',
    order: 7,
  },
  {
    title: 'Entreprises',
    group: 'apps',
    icon: '$iconEnterprise',
    name: 'Companies',
    order: 8,
  },
];

const MenuAdmin = Menu.concat(menu);

export default sortMenu(MenuAdmin);
